/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faThumbsUp} from '@fortawesome/pro-duotone-svg-icons';

const PdApprovalsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faThumbsUp} {...props} />
);

export default PdApprovalsIcon;
